import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useRecomposeAddress() {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const decomposeAddress = (addressGuid, refreshData) => {
    setLoading(true);
    axiosClient
      .delete(`/InventoryAddress/DeComposse?guid=${addressGuid}`)
      .then(res => {
        if (res.status === 200) {
          //   const data = {
          //     ...res.data.value,
          //     children: [],
          //   };
          refreshData();
          enqueueSnackbar(res.data?.message, { variant: 'success' });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, decomposeAddress];
}
